import React from 'react';
import { Result, Button, Space, Typography } from 'antd';
import { HomeOutlined, RollbackOutlined } from '@ant-design/icons';

const { Text } = Typography;

const NotFound = () => {
  return (
    <div style={{ 
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#f0f2f5'
    }}>
      <Result
        status="404"
        title="404"
        subTitle={
          <Space direction="vertical" size="small">
            <Text strong style={{ fontSize: '24px' }}>Page Not Found</Text>
            <Text type="secondary">Sorry, the page you visited does not exist.</Text>
          </Space>
        }
        extra={
          <Space size="middle">
            <Button 
              type="primary" 
              icon={<HomeOutlined />}
              size="large"
              onClick={() => window.location.href = '/'}
            >
              Back to Home
            </Button>
            <Button 
              icon={<RollbackOutlined />}
              size="large"
              onClick={() => window.history.back()}
            >
              Go Back
            </Button>
          </Space>
        }
        style={{
          background: 'white',
          padding: '48px',
          borderRadius: '8px',
          boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
        }}
      />
    </div>
  );
};

export default NotFound; 